import { render, staticRenderFns } from "./IncidentCharting.vue?vue&type=template&id=36188e38&scoped=true"
import script from "./IncidentCharting.vue?vue&type=script&lang=js"
export * from "./IncidentCharting.vue?vue&type=script&lang=js"
import style0 from "./IncidentCharting.vue?vue&type=style&index=0&id=36188e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36188e38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VList,VListItem,VMenu,VSpacer})
